'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _safe = require('../transforms/safe');

exports.default = function thirdPass(compiler, programPath) {
  programPath.traverse({
    CallExpression(path) {
      (0, _safe.maybeTransformSafe)(path);
    }, MemberExpression(path) {
      (0, _safe.maybeTransformSafe)(path);
    } });
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@oigroup/babel-plugin-lightscript/lib/visitors/thirdPass.js
// module id = 1007
// module chunks = 0